"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrationsManagerFactory = void 0;
var browser_1 = require("../utils/constants/browser");
var pluggable_1 = require("./pluggable");
var GoogleAnalyticsToSplit_1 = require("./ga/GoogleAnalyticsToSplit");
var SplitToGoogleAnalytics_1 = require("./ga/SplitToGoogleAnalytics");
/**
 * IntegrationsManager factory for the browser variant of the isomorphic JS SDK.
 * The integrations manager instantiates integration modules, and bypass tracked events and impressions to them.
 *
 * @param integrations valid integration settings object for browser sdk
 * @param params information of the Sdk factory instance that integrations can access to
 *
 * @returns integration manager or undefined if `integrations` are not present in settings.
 */
function integrationsManagerFactory(integrations, params) {
    // maps integration config items into integration factories to reuse the pluggable integration manager
    var integrationFactories = integrations
        .map(function (integrationOptions) {
        switch (integrationOptions.type) {
            case browser_1.GOOGLE_ANALYTICS_TO_SPLIT: return (0, GoogleAnalyticsToSplit_1.GoogleAnalyticsToSplit)(integrationOptions);
            case browser_1.SPLIT_TO_GOOGLE_ANALYTICS: return (0, SplitToGoogleAnalytics_1.SplitToGoogleAnalytics)(integrationOptions);
        }
    })
        .filter(function (integrationFactory) {
        return integrationFactory && typeof integrationFactory === 'function';
    });
    return (0, pluggable_1.pluggableIntegrationsManagerFactory)(integrationFactories, params);
}
exports.integrationsManagerFactory = integrationsManagerFactory;
